<template>
  <div v-if="bannerConfig" class="snapchat-upsell-banner" @click="onClick">
    <!-- Sticker Image -->
    <div class="banner-sticker" :style="{ width: bannerConfig.stickerWidth }">
      <img :src="bannerConfig.stickerUrl" alt="Snapchat Banner" class="sticker-image" />
    </div>

    <!-- Content Column (Title + Button) -->
    <div class="banner-content-column">
      <h2 class="banner-title" v-localize="bannerConfig.titleKey"></h2>

      <div class="snapchat-button">
        <img class="snapchat-icon" :src="bannerConfig.buttonUrl" draggable="false" />
        <span v-localize="bannerConfig.buttonKey"></span>
      </div>
    </div>
  </div>
</template>

<script>
import SendClientMessage from '@/services/SendClientMessage';
import MetricsHelper from '@/services/MetricsHelper';
import { BitmojiAppSnapchatUpsellActionEnum } from '@/enum/bitmoji_app_snapchat_upsell_action';
import { BitmojiAppSnapchatUpsellTypeEnum } from '@/enum/bitmoji_app_snapchat_upsell_type';
import FeatureGating from '@/services/FeatureGating';

export default {
  name: 'SnapchatUpsellBanner',
  props: {
    categoryKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    bannerConfig() {
      switch (this.categoryKey) {
        case 'hair':
          return {
            stickerUrl: FeatureGating.isAppDeprecationBannerEnabled()
              ? require('@/assets/bitmoji_group.png')
              : require('@/assets/traits_banner_animation.gif'),
            titleKey: FeatureGating.isAppDeprecationBannerEnabled()
              ? 'AppDeprecationBannerTitle'
              : 'SnapchatUpsellBannerTraitTitle',
            buttonUrl: FeatureGating.isAppDeprecationBannerEnabled()
              ? undefined
              : require('@/assets/snapchat_ghost.svg'),
            buttonKey: FeatureGating.isAppDeprecationBannerEnabled()
              ? 'AppDeprecationBannerButtonText'
              : 'SnapchatUpsellBannerButtonText',
            stickerWidth: FeatureGating.isAppDeprecationBannerEnabled() ? '35%' : '30%',
          };
        case 'outfit':
          return {
            stickerUrl: FeatureGating.isAppDeprecationBannerEnabled()
              ? require('@/assets/bitmoji_group.png')
              : require('@/assets/fashion_banner_animation.gif'),
            titleKey: FeatureGating.isAppDeprecationBannerEnabled()
              ? 'AppDeprecationBannerTitle'
              : 'SnapchatUpsellBannerFashionTitle',
            buttonUrl: FeatureGating.isAppDeprecationBannerEnabled()
              ? undefined
              : require('@/assets/snapchat_ghost.svg'),
            buttonKey: FeatureGating.isAppDeprecationBannerEnabled()
              ? 'AppDeprecationBannerButtonText'
              : 'SnapchatUpsellBannerButtonText',
            stickerWidth: FeatureGating.isAppDeprecationBannerEnabled() ? '35%' : '30%',
          };
        default:
          return null;
      }
    },
  },
  methods: {
    onClick() {
      if (FeatureGating.isAppDeprecationBannerEnabled()) {
        // Log click for appropriate upsell type
        const upsellType =
          this.categoryKey === 'hair'
            ? BitmojiAppSnapchatUpsellTypeEnum.AVATAR_TAB_DEPRECATION_BANNER
            : BitmojiAppSnapchatUpsellTypeEnum.BUILDER_TAB_DEPRECATION_BANNER;
        MetricsHelper.logBitmojiAppSnapchatUpsell(
          BitmojiAppSnapchatUpsellActionEnum.BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_CLICK,
          upsellType,
        );
        SendClientMessage.presentAppDeprecationNotice(this.categoryKey);
        return;
      }
      // Log click for appropriate upsell type
      const upsellType =
        this.categoryKey === 'hair'
          ? BitmojiAppSnapchatUpsellTypeEnum.AVATAR_TAB_BANNER
          : BitmojiAppSnapchatUpsellTypeEnum.BUILDER_TAB_BANNER;
      MetricsHelper.logBitmojiAppSnapchatUpsell(
        BitmojiAppSnapchatUpsellActionEnum.BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_CLICK,
        upsellType,
      );
      SendClientMessage.redirectToSnapchat(this.categoryKey);
    },
  },
  mounted() {
    if (this.bannerConfig) {
      const upsellType = FeatureGating.isAppDeprecationBannerEnabled()
        ? this.categoryKey === 'hair'
          ? BitmojiAppSnapchatUpsellTypeEnum.AVATAR_TAB_DEPRECATION_BANNER
          : BitmojiAppSnapchatUpsellTypeEnum.BUILDER_TAB_DEPRECATION_BANNER
        : this.categoryKey === 'hair'
        ? BitmojiAppSnapchatUpsellTypeEnum.AVATAR_TAB_BANNER
        : BitmojiAppSnapchatUpsellTypeEnum.BUILDER_TAB_BANNER;
      MetricsHelper.logBitmojiAppSnapchatUpsell(
        BitmojiAppSnapchatUpsellActionEnum.BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_IMPRESSION,
        upsellType,
      );
    }
  },
};
</script>

<style scoped>
.snapchat-upsell-banner {
  display: flex;
  align-items: center;
  background: #39ca8e;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  gap: 8px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.banner-sticker {
  flex-shrink: 0;
  min-width: 60px;
}

.sticker-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.banner-content-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.banner-title {
  color: white;
  font-size: 22px;
  font-weight: 600;
  font-family: 'Avenir Next';
  margin: 0;
  line-height: 1.2;
  text-align: left;
}

.snapchat-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 85%;
  height: 16px;
  color: #000;
  border: none;
  border-radius: 20px;
  background: #fffc00;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Avenir Next';
  transition: all 0.2s ease;
  pointer-events: none;
}

.snapchat-upsell-banner:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.snapchat-upsell-banner:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.snapchat-icon {
  margin-right: 6px;
}
</style>
